import React from 'react'

export default function UniqueReferenceBadge() {
	return (
		<span
			className="unique-reference-field"
			title="Must be unique in Job App and OLS"
		>
			Must be unique
		</span>
	)
}
